<lib-modal-layout [title]="data.title" [subtitle]="data.subTitle">
  <p class="text-center">{{ data.pTitle }}</p>

  <form [formGroup]="userForm">
    <h4>User Information</h4>
    <div class="form-field-container">
      <div class="form-field">
        <lib-form-text label="First Name" formControlName="firstName"> </lib-form-text>
      </div>
      <div class="form-field">
        <lib-form-text label="Last Name" formControlName="lastName"> </lib-form-text>
      </div>
      <div class="form-field">
        <lib-form-text label="Email" formControlName="email"> </lib-form-text>
      </div>
      <div class="form-field"></div>
      <div class="form-field">
        <p>{{ data.user?.createDate ? 'Created Date: ' + (data.user?.createDate | date : 'mm/dd/yyyy') : '' }}</p>
      </div>
    </div>
    <h4>Access Information</h4>
    <p>
      Wholesale administrators are privileged users that have access to your account, agencies and quotes. This role
      requires additional security enforcement. Use discretion when granting users with these permissions.
    </p>
    <div class="form-field-container">
      <div class="form-field">
        <lib-form-dropdown label="Role" formControlName="role" [options]="roles()"> </lib-form-dropdown>
      </div>
      <div class="form-field">
        <lib-form-dropdown label="Status" formControlName="status" [options]="statusOptions()"> </lib-form-dropdown>
      </div>
    </div>
  </form>
  @if (data.pClosing) {
    <p class="text-center">{{ data.pClosing }}</p>
  }
  <div class="upload-button">
    <lib-button
      [cssType]="'btn-primary'"
      [icon]="'rightarrow'"
      [text]="data.button"
      [size]="'large'"
      (click)="submit()"
    ></lib-button>
  </div>
</lib-modal-layout>
